var Pixel = Pixel || {};

Pixel.Criteo = (function (_pixelBase) {

    return _pixelBase.extend({
        initialize: function (opts) {
            this._deviceType = opts.deviceType;
            this._criteoID = opts.criteoID;
        },

        pageView: function () {
        },

        basketUpdate: function (data) {
            if (data && data.Items) {
                var _items = $.map(data.Items, function (i) {
                    return {
                        id: i.HashedId || i.ItemID,
                        price: i.Price,
                        quantity: i.Qty
                    };
                });

                window.criteo_q = window.criteo_q || [];
                window.criteo_q.push(
                    { event: "setAccount", account: this._criteoID },
                    { event: "setSiteType", type: this._deviceType },
                    { event: "setEmail", email: data.CIDSHA, hash_method: "sha256" },
                    { event: "viewBasket", item: _items }
                );
            }
        },

        purchaseSuccess: function (opts) {
            opts = opts || {};
            var data = opts.OrderInfoResult;

            if (data && data.Items) {

                var _items = $.map(data.Items, function (i) {
                    return {
                        id: i.HashedId || i.ID,
                        price: i.Price,
                        quantity: i.Quantity
                    };
                });

                window.criteo_q = window.criteo_q || [];
                window.criteo_q.push(
                    { event: "setAccount", account: this._criteoID },
                    { event: "setSiteType", type: this._deviceType },
                    { event: "setEmail", email: data.CIDSHA, hash_method: "sha256" },
                    { event: "trackTransaction", id: data.InvoiceNo, item: _items }
                );
            }
        }
    });
})(Pixel.PixelBase);

!function (Pixel, globalSettings) {
    if (globalSettings.CriteoEnabled) {
        var deviceType = /iPad/.test(navigator.userAgent) ? "t" : /Mobile|iP(hone|od)|Android|BlackBerry|IEMobile|Silk/.test(navigator.userAgent) ? "m" : "d";
        new Pixel.Criteo({
            deviceType: deviceType,
            criteoID: globalSettings.CriteoID
        });
    }
}(Pixel, GlobalSettings);
